enum EsType {
  category = 'Category',
  company = 'Company',
  product = 'Product',
  news = 'News',
  all = 'all'
}

export { EsType };
